import Splide from '@splidejs/splide';

function initializeHomeCredentialsBlock() {
    const sliders = document.querySelectorAll('.home-credentials .home-credentials__slider');

    sliders.forEach(function(slider) {
        if( slider.splide ) {
            slider.splide.destroy(true);
        }

        const splide = new Splide(slider, {
            type: 'slide',
            arrows: false,
            pagination: false,
            autoplay: false,
            speed: 700,
            drag: true,
            snap: true,
            focus: 0,
            gap: 0,
            trimSpace: true,
            perMove: 1,
            autoWidth: true,
            breakpoints: {
                768: {
                    autoWidth: false,
                    perPage: 1,
                    perMove: 1
                }
            }
        });

        splide.mount();

        // Ensure measurements are recalculated after first paint/font/layout stabilization.
        requestAnimationFrame(function() {
            splide.refresh();
        });

        window.addEventListener('load', function() {
            splide.refresh();
        }, { once: true });

        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                splide.refresh();
            }, 120);
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if( window.acf ) {
        window.acf.addAction('render_block_preview/type=home-credentials', initializeHomeCredentialsBlock);
    } else {
        initializeHomeCredentialsBlock();
    }
});
